// -----------------------------------------
// LENIS SMOOTH SCROLL
// -----------------------------------------

const lenis = new Lenis({
  duration: 1.2,
  lerp: 0.1,
  wheelMultiplier: 1.1,
  direction: "vertical",
  gestureDirection: "vertical",
  smooth: true,
  mouseMultiplier: 1,
  smoothTouch: false,
  touchMultiplier: 2,
  infinite: false,
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);


// -----------------------------------------
// PAGE TRANSITION (Codrops clip-path style)
// -----------------------------------------

gsap.registerPlugin(CustomEase);
const pageEase = CustomEase.create(
  "pageTransition",
  "M0,0 C0.38,0.05 0.48,0.58 0.65,0.82 0.82,1 1,1 1,1"
);

const $transition = $(".transition");
const $pageContent = $("[data-page-content]");
const excludedClass = "no-transition";
const transitionDur = 0.7;
const prefetched = new Set();

function prefetchUrl(url) {
  if (!url || prefetched.has(url)) return;
  prefetched.add(url);
  const link = document.createElement("link");
  link.rel = "prefetch";
  link.href = url;
  link.as = "document";
  document.head.appendChild(link);
}

function isInternalNavLink($a) {
  const href = $a.attr("href");
  if (!href) return false;
  const sameHost = $a.prop("hostname") === window.location.host;
  const hasHash = href.indexOf("#") !== -1;
  const isExcluded = $a.hasClass(excludedClass);
  const isBlank = $a.attr("target") === "_blank";
  return sameHost && !hasHash && !isExcluded && !isBlank;
}

// Prefetch on hover/focus — most requests already cached when user clicks
$("a").on("mouseenter focus", function () {
  const $this = $(this);
  if (isInternalNavLink($this)) prefetchUrl($this.attr("href"));
});

// On Page Load — reveal page (overlay clips away bottom-up)
if ($transition.length) {
  const overlay = $transition[0];

  // Start state set by CSS: opacity 1, clip-path inset(0% 0% 0% 0%)
  gsap.to(overlay, {
    clipPath: "inset(0% 0% 100% 0%)",
    duration: transitionDur,
    ease: pageEase,
    onComplete: () => {
      gsap.set(overlay, { opacity: 0, clipPath: "inset(100% 0% 0% 0%)" });
    },
  });
}

// Internal link click — animate page out + overlay cover, then navigate
$("a").on("click", function (e) {
  const $this = $(this);

  if (isInternalNavLink($this) && $transition.length) {
    e.preventDefault();
    const url = $this.attr("href");
    prefetchUrl(url); // backup for touch users who didn't hover
    const overlay = $transition[0];

    // Reset overlay to ready state (offscreen below)
    gsap.set(overlay, {
      opacity: 1,
      clipPath: "inset(100% 0% 0% 0%)",
    });

    const tl = gsap.timeline({
      onComplete: () => { window.location = url; },
    });

    // Outgoing page: scale down, fade, shift up (small distance)
    if ($pageContent.length) {
      tl.to($pageContent[0], {
        y: "-10vh",
        opacity: 0.5,
        scale: 0.9,
        transformOrigin: "center top",
        duration: transitionDur,
        force3D: true,
        ease: pageEase,
      }, 0);
    }

    // Overlay: reveal from bottom upward to fully cover
    tl.to(overlay, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: transitionDur,
      force3D: true,
      ease: pageEase,
    }, 0);
  }
});

// Back button — force reload so overlay fires fresh
window.onpageshow = function (event) {
  if (event.persisted) window.location.reload();
};


// -----------------------------------------
// COPY EMAIL BUTTON
// -----------------------------------------

new Clipboard("[data-clipboard-text]");


// -----------------------------------------
// TOOLTIPS
// -----------------------------------------

tippy("[data-tippy-content]", {
  trigger: "click",
  placement: "bottom",
  animation: "scale",
  duration: 200,
  arrow: true,
  arrowType: "round",
  delay: [0, 100],
  theme: "light",
  maxWidth: 220,
  interactive: true,
  onShow(instance) {
    instance._autoHideTimeout = setTimeout(() => instance.hide(), 2500);
  },
  onHide(instance) {
    clearTimeout(instance._autoHideTimeout);
  },
});
